export const getPlaceholderByType = (type) => {
  switch (type) {
    case "cargo":
      return "Certificate Number";
    case "invoice":
      return "Invoice Number";
    case "b2b":
      return "Certificate Number";
    default:
      return "Key";
  }
};